import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lock, MessageCircle, Send, Users, Download, ArrowRight } from "lucide-react";
import client from "../../lib/api";
import { waLink } from "../join/pixel";

const Btn = ({ href, to, testid, cls, icon: Icon, children }) => {
  const c = `flex items-center gap-3 px-4 py-3.5 text-sm font-semibold active:scale-[0.98] hover:brightness-110 transition-[filter,transform] duration-200 ${cls}`;
  return to ? <Link to={to} data-testid={testid} className={c}><Icon size={18} />{children}</Link>
    : <a href={href} target="_blank" rel="noreferrer" data-testid={testid} className={c}><Icon size={18} />{children}</a>;
};

export function JoinPremiumBox({ joinUrl }) {
  const [cfg, setCfg] = useState({});
  useEffect(() => { client.get("/public/join-config").then(({ data }) => setCfg(data)).catch(() => {}); }, []);
  const wa = waLink(cfg.wa_chat_number, "Hi Fateh FX admin 👋 Mujhe Premium signals (TP + SL ke saath) join karne hain 🙏");
  return (
    <div className="mt-6 border border-gold/40 p-5" style={{ background: "rgba(212,175,55,0.06)" }} data-testid="signal-join-box">
      <div className="flex items-start gap-2 text-white font-semibold"><Lock size={16} className="text-gold mt-0.5 shrink-0" />To get full calls with TP and SL, join Premium</div>
      <p className="text-xs text-slate-400 mt-1.5">Stop Loss sirf Premium members ko milta hai. Admin ko WhatsApp karein, ya neeche se free community join karein.</p>
      <div className="grid gap-2 mt-4">
        {wa && <Btn href={wa} testid="signal-wa-chat" cls="bg-[#25D366] text-black" icon={MessageCircle}>WhatsApp pe admin se baat karein</Btn>}
        {joinUrl && <Btn href={joinUrl} testid="signal-join-premium-btn" cls="bg-gold text-black" icon={ArrowRight}>Join Premium</Btn>}
      </div>
      <div className="text-[10px] uppercase tracking-widest text-slate-500 mt-5 mb-2">Free me judiye</div>
      <div className="grid sm:grid-cols-3 gap-2">
        {cfg.free_telegram_url && <Btn href={cfg.free_telegram_url} testid="signal-free-telegram" cls="border border-[#229ED9] text-[#229ED9]" icon={Send}>Telegram free channel</Btn>}
        {cfg.wa_community && <Btn href={cfg.wa_community} testid="signal-wa-community" cls="border border-[#25D366] text-[#25D366]" icon={Users}>WhatsApp community</Btn>}
        <Btn to="/app" testid="signal-get-app" cls="border border-gold text-gold" icon={Download}>App download karein</Btn>
      </div>
    </div>
  );
}
